import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmployeeTable.css';
import './tablestyle.css';


const ModalityTable = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [modalityList, setModalityList] = useState([]);
  const [loading, setLoading] = useState(true);
   const navigate = useNavigate();

   const fetchModalityList = () => {
    setLoading(true);
    fetch(`${baseUrl}/getModalities`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setModalityList(data.data);
        } else {
          setModalityList([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching Modality list:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchModalityList();
  }, []);

  const handleEditClick = async (id) => {
 
    navigate(`/modality/edit/${id}`);
  }

  const handleDeleteClick = async (id) => {
    if (!window.confirm('Are you sure you want to delete this Modality?')) {
      return;
    }

    try {
      const response = await fetch(
        `${baseUrl}/deleteModalityById/${id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const result = await response.json();

      if (result.status) {
        alert('Modality deleted successfully!');
        fetchModalityList(); // refresh table
      } else {
        alert(result.message || 'Failed to delete Modality.');
      }
    } catch (error) {
      console.error('Error deleting Modality:', error);
      alert('An error occurred while deleting.');
    }
  };

  if (loading) {
    return <div>Loading Modality data...</div>;
  }

  return (
    <div className="employee-table-container">
      <table className="employee-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Modality</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Created On</th>
            <th>Modified By</th>
            <th>Modified On</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {modalityList.length > 0 ? (
            modalityList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.mod_name}</td>
                <td>
                  <span
                    className={`status-badge ${
                      item.status === 'A' ? 'active' : 'inactive'
                    }`}
                  >
                    {item.status === 'A' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{item.created_by}</td>
                <td>{item.created_on}</td>
                <td>{item.modified_by || '-'}</td>
                <td>{item.modified_on || '-'}</td>
                <td>
                  <button className="action-button edit" onClick={() => handleEditClick(item.id)}>Edit</button>
                  <button className="action-button delete"  onClick={() => handleDeleteClick(item.id)}>Delete</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                No Modality data found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ModalityTable;
